// Mirror of backoffice/types/brands/clients/DISNEY/logo-vs-logo-matchday-prefix.ts — keep in sync.
// The frontend can't import outside src/, so both copies must match (same pattern as folder-names).

export type MatchdayPrefix = 'fecha' | 'jornada';

const PREFIX_BY_LEAGUE: Record<string, MatchdayPrefix> = {
  ligue1: 'jornada',
  'la-liga': 'jornada',
  bundesliga: 'jornada',
  'premier-league': 'jornada',
  'serie-a': 'jornada',
  eredivisie: 'jornada',
  'urba-top14': 'fecha',
  'brasileirao-serie-a': 'fecha',
  'brasileirao-serie-b': 'fecha',
  'brasileirao-serie-c': 'fecha',
  copinha: 'fecha'
};

export const DEFAULT_PREFIX: MatchdayPrefix = 'jornada';

export const matchdayPrefix = (league: string | undefined): MatchdayPrefix =>
  (league && PREFIX_BY_LEAGUE[league]) || DEFAULT_PREFIX;
